module.exports = __webpack_public_path__ + "img/illu-shell.1b4bdde0.svg";